// extracted by mini-css-extract-plugin
export default {"container":"contragent-edit_container__0FW7G","items":"contragent-edit_items__8anE+","buttons":"contragent-edit_buttons__82Fk7","checkedIcon":"contragent-edit_checkedIcon__7JR2u"};